import "./index.css";

const Line = () => {
  return <div className="base-line"></div>;
};

export default Line;
